import _ from 'lodash';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit, ViewEncapsulation, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, DestroyRef, inject } from '@angular/core';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { UntypedFormArray } from '@angular/forms';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Subject } from 'rxjs';
import { first, debounceTime } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { selectCampaignSelected } from '../../features/campaign.selectors';
import { ToastService } from 'app/toast/services/toast.service';
import * as CampaignActions from '../../features/campaign.actions';
import * as DialogActions from 'app/dialog/features/dialog.actions';
import { setPresetOptionList } from '../../features/option.actions';
import { CampaignOptionListService } from '../../services/campaign-option-list.service';
import { CampaignFormService, CampaignOptionListEventHandlerService } from '../../services';
import { AuctionManageService } from 'app/manage-auctions/services/auction-manage/auction-manage.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { CAMPAIGN_TYPE } from 'app/virtual-event/virtual-event.enums';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-campaign-option-list',
  templateUrl: './campaign-option-list.component.html',
  styleUrls: ['./campaign-option-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class CampaignOptionListComponent implements OnInit, AfterViewInit, OnDestroy {
  destroyRef = inject(DestroyRef)
  @ViewChild(CdkVirtualScrollViewport)
  public viewport: CdkVirtualScrollViewport;

  @Input()
  public index: number = 0;

  @Output() onEdit = new EventEmitter<any>();
  @Output() onDelete = new EventEmitter<any>();

  public selectedCampaign$ = this.store.pipe(
    select(selectCampaignSelected),
  );

  public updatedList = [];
  public list = [];

  public campaign = null
  public formGroup = null;

  public collection = null;
  public options: UntypedFormArray = null;

  public height: number = 93;
  public position: number = 0;
  public cdkDragStartedPosition = 0;
  public cdkDragEndedPosition = 0;

  public auctionItem = null;

  public styles = { height: '93px' };
  public stylesPadding = {};

  constructor(
    private store: Store,
    private toastService: ToastService,
    public campaignFormService: CampaignFormService,
    public campaignOptionListService: CampaignOptionListService,
    public campaignOptionListEventHandlerService: CampaignOptionListEventHandlerService,
    public cdr: ChangeDetectorRef,
    public auctionManageService: AuctionManageService,
    private clipboard: Clipboard,
  ) { }

  ngOnInit(): void {
    this.formGroup = this.campaignFormService.campaignTypeData;
    this.campaign = this.campaignFormService.form;
    this.stylesPadding = this.campaign.get("type").value===6 || this.campaign.get("type").value===4 ? { padding: '12px' } : {padding: '20px'}

    this.campaignOptionListEventHandlerService.onUpdateCampaignOptionList.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((list) => {
      this.updatedList = list;
      this.onUpdateOptionList.bind(this)()
    });

    this.campaignOptionListEventHandlerService.onSearchCampaignOptionList.pipe(
     takeUntilDestroyed(this.destroyRef)
    ).subscribe(this.onUpdateOptionList.bind(this));

    this.onUpdateOptionList();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      let indexToScroll = this.index - 1;
      if(this.index <= 3 ){
        indexToScroll = 0;
        return
      }
      this.viewport.scrollToIndex(this.index, "smooth");
    }, 500);

    this.viewport.scrolledIndexChange.pipe(
      debounceTime(500) 
    ).subscribe(() => {
      window['$']('[data-toggle="tooltip"]').tooltip();
    });
  }

  ngOnDestroy() {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

  onUpdateOptionList() {
    this.list = this.campaignOptionListService.getActiveListBySearch();

    const length = this.list.length;
    const height = length < 1 ? 93: length * 93;

    this.height = height > 930 ? 930: height;
    this.styles = { height: `${this.height}px` };

    this.cdr.markForCheck();
  }

  isShowingCombo(data){
    if(data.ticketCombo){
      if(data.ticketCombo.length > 0){
        return true
      } 
    }
    return false
  }

  getPresetOptionImageUrl(option) {
    const imageUrls = option.imageUrls || null;
    if(imageUrls) {
      return imageUrls.length > 0 ? imageUrls[0] : "/images/org_logo_default_v2.svg";
    }

    return _.isEqual(option.imageUrl, '/images/blank_2x1.png') || _.isEqual(option.imageUrl, '') ?
      "/images/org_logo_default_v2.svg": option.imageUrl;
  }

  onCDKDragStarted(event) {
    this.cdkDragStartedPosition = this.position
  }

  onCDKDragEnded(event) {
    this.cdkDragEndedPosition = this.position
  }

  dropOption(event) {
    const { campaignOptionListService, list } = this;
    const { item: { data: { index: itemIndex } } }: any = event;

    const previousFoundIndex = _.findIndex(list, element => {
      return element.index == itemIndex;
    });
    const currentFoundIndex = previousFoundIndex + (event.currentIndex - event.previousIndex);
    const currentIndex = list[currentFoundIndex].index;

    moveItemInArray(campaignOptionListService.list, itemIndex, currentIndex);

    this.store.dispatch({
      type: setPresetOptionList.type,
      data: _.map(campaignOptionListService.list, ({ data }) => data)
    });
  }

  editOption({ data: option, index }) {
    this.onEdit.next({ option, index });
  }

  onCopyOptionLink({ data: option }) {
    this.selectedCampaign$.pipe(
      first(),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((campaign) => {
      const handle = _.get(window['localOrgData'], 'user.handle', 'handle');
      const intid = _.get(campaign, 'intid', 0);
      const optionId = _.get(option, 'id', 0);
      const optionQParam = campaign.type === CAMPAIGN_TYPE.AUCTION ? 'itemId' : 'oid';

      const url = `${ location.origin }/@${handle}@${intid}?${optionQParam}=${optionId}`;
      this.clipboard.copy(url);
  
      this.toastService.show('success', 'Copied Successfully!', {delay: 2000});
    })
  }

  generateConfirmAction(name, initialState) {
    return DialogActions.openDialog({
      payload: {
        name,
        options: {
          size: 'small',
          modalClass:'modal--paybee modal-sm',
          containerClass:'mdb-modal-backdrop-paybee',
          ignoreBackdropClick: true
        },
        initialState
      }
    });
  }

  removeOption(option) {
    const hideCustom = _.get(this.formGroup.controls, 'hideCustom.value', true);
    const isLastOption = this.campaignOptionListService.activeList.length < 2;

    if(hideCustom && isLastOption) { 
      this.toastService.show('danger', 'You cannot remove last Preset Option', {delay: 2000});
      return;
    }

    this.selectedCampaign$.pipe(
      first(),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((campaign) => {
      this.store.dispatch({
        type: CampaignActions.newDeleteCampaignPresetOption.type,
        payload: { campaign, option }
      });
      this.onDelete.emit(option)
    })
  }

  getOptionErrorMessage(element) {
    const { errors } = element;
    if(errors.buyItNowOnlyItem) {
      return 'Incorrect value of "Min Bid" and "Bid Increment" edit and fix';
    }
    if(errors.inventory) {
      return 'Inventory count must be non zero, edit and fix';
    }
    return 'Invalid!';
  }

  getSold(element){
    let {
      multiplier,
      bookedCount = 0,
      inventory,
      hideInventory
    } = element.data;

    let multiplierNum = multiplier ? multiplier : 1
    if(hideInventory){
      if(bookedCount){
        return  `${Math.floor(bookedCount / multiplierNum)} Sold.` 
      }else{
        return 'None sold yet.'
      }
    }else{
      if(bookedCount){
        const soldText = inventory > 0 ? `of ${inventory} sold.` : 'sold.';
        return `${Math.floor(bookedCount / multiplierNum)} ${soldText}`; 
      } else{
        const soldText = inventory > 0 ? `0 of ${inventory} sold.` : 'None sold yet.';
        return `${soldText}`; 
      }
    }
  }

  getSoldAuction(element){
   let { soldCount, count} = element.data;

   if(soldCount){
      return `${soldCount} of ${count} sold.`;
   }else{
    return `0 of ${count} sold.`
   }
  }

  moveTo(event: any) {
    const { campaignOptionListService: { list } } = this;

    const position = parseInt(event.position);
    if(position >= 0 && list.length > position) {
      moveItemInArray(list, event.index, event.position);
      this.store.dispatch({
        type: setPresetOptionList.type,
        data: _.map(list, ({ data }) => data)
      });
    }
  }

  getAmount(anount){
    let newAmount = Math.round(anount)
    return window['utils'].getAmountDisplay(newAmount);
  }

  getItemStatus({ data: option }) {
    const currentDateTime = Math.floor(new Date().getTime()/1000);

    let color = null;
    let status = null;
    if(option.optionStartDate > 0 && option.optionStartDate > currentDateTime) {
      color = 'yellow';
      status = 'Not Started';
    } else if(option.optionEndDate > 0 && currentDateTime > option.optionEndDate) {
      color = 'red';
      status = 'Expired';
    } else {
      color = 'green'
      status = 'Active';
      return '';
    }
    return  `<div class="group-ticket-info__container group-ticket-info__container--${color} px-2 py-1" [innerHTML]="getItemStatus(element)">
      <div class="group-ticket-info__content text-nowrap" style="font-weight: 400;">
        ${status}
      </div>
    </div>`;
  }
}
